// Components==============
import addFolder from 'actions/group/store';
import Button from 'components/UI/Button';
import { TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { GroupContext } from 'screens/Group';
import { useFormValues } from 'utilities/useFormValues';
import './Modals.module.scss';
// =========================

export default function AddNewFolderModal({ setModalIsOpen }) {
    const { group } = useContext(GroupContext);

    const dispatch = useDispatch();

    const { formValues, handleChange } = useFormValues({
        name: '',
    });

    function handleSubmit(e) {
        e.preventDefault();

        return dispatch(
            addFolder({
                parent_id: group.id,
                name: formValues.name,
            })
        ).then(() => setModalIsOpen(false));
    }

    return (
        <Modal closeModal={() => setModalIsOpen(false)}>
            <div styleName="content">
                <h3>Map aanmaken</h3>
                <p>Geef de map een naam</p>
                <form onSubmit={handleSubmit}>
                    <div>
                        <TextInput
                            label="Naam"
                            onChange={handleChange}
                            name="name"
                            value={formValues.name}
                        />
                    </div>
                    <div>
                        <Button>Opslaan</Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
